import { c as _c } from "react/compiler-runtime";
import { useWaveById } from "@/hooks/useWaveById";
import ChatItemHrefButtons from "../ChatItemHrefButtons";
import WaveItem from "./WaveItem";
export default function WaveItemChat(t0) {
  const $ = _c(10);
  const {
    href,
    waveId
  } = t0;
  const wave = useWaveById(waveId);
  const t1 = wave?.wave;
  let t2;
  if ($[0] !== href || $[1] !== t1 || $[2] !== waveId) {
    t2 = <div className="tw-flex-1 tw-min-w-0"><WaveItem wave={t1} userPlaceholder={href} titlePlaceholder={waveId} /></div>;
    $[0] = href;
    $[1] = t1;
    $[2] = waveId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `/waves/${waveId}`;
  let t4;
  if ($[4] !== href || $[5] !== t3) {
    t4 = <ChatItemHrefButtons href={href} relativeHref={t3} />;
    $[4] = href;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <div className="tw-flex tw-items-stretch tw-w-full tw-gap-x-1">{t2}{t4}</div>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}